<template>
    <section class="esesja-modal send-meeting-regarding-modal">
        <section class="esesja-modal__wraper">
            <section class="esesja-modal__wraper__header">
                <h3 class="esesja-modal__wraper__header__title">{{ $t('com.file.prepare-meeting-invitation.editor-title') }}</h3>
                <button class="esesja-modal__wraper__header__exit-btn"
                        @click=" (e)=>{e.preventDefault(); this.$store.commit('setPrepareMeetingInvitationModalStatus', false);}">
                    <img src="@/assets/icons/components/exit-btn.svg" />
                </button>
            </section>
            <perfect-scrollbar class="esesja-modal__wraper__body">
                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.prepare-meeting-invitation.addressing-list-label') }} ({{selectedUsers.length}})</label>
                <section class="esesja-modal__row esesja-modal__row__as-column">
                    <Multiselect ref="searchUsers"
                                 v-model="selectedUsers"
                                 mode="tags"
                                 :placeholder="$t('com.global.search')"
                                 :close-on-select="false"
                                 :searchable="true"
                                 class="esesja-multiselect"
                                 :noResultsText="$t('com.global.no-results')"
                                 :noOptionsText="$t('com.global.no-options')"
                                 :groups="true"
                                 :options="availableUsers"
                                 :searchFilter="customSearchFilter"
                                 @select="selectedOptions">
                            <template #tag="{ option, handleTagRemove, disabled  }">
                                <MultiselectPersonTag :option="option" :disabled="disabled" @click="handleTagRemove(option, $event)" />
                            </template>
                    </Multiselect>
                </section>

                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.prepare-meeting-invitation.selected-session-label') }}</label>
                <section class="esesja-modal__row">
                    <select class="esesja-modal__wraper__body__input" v-model="selectedSession" @change="checkSelectedSession($event)">
                        <option v-for="s in sessionsToSelect" :value="s.id" :key="s.id"> {{showSessionName(s, 90)}} {{showDate(s.meeting_date)}}</option>
                    </select>
                </section>

                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.prepare-meeting-invitation.entrie-invitation-label') }}</label>
                <section class="esesja-modal__row">
                    <ckeditor :editor="editor" :config="editorConfig" v-model="header"></ckeditor>
                </section>

                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.prepare-meeting-invitation.invitation-text-label') }}</label>
                <section class="esesja-modal__row">
                    <ckeditor :editor="editor" :config="editorConfig" v-model="body"></ckeditor>
                </section>

                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.prepare-meeting-invitation.footer-label') }}</label>
                <section class="esesja-modal__row">
                    <ckeditor :editor="editor" :config="editorConfig" v-model="footer"></ckeditor>
                    <section style="font-size: 11px;">*{{$t('com.file.prepare-meeting-invitation.footer-logo-information')}}</section>
                </section>

                <section class="esesja-modal__row">
                    <p>
                        <img src="../../../assets/icons/components/tooltip.svg" style="max-width: 20px; margin-right: 5px;" />
                        <span class="tooltip" @mouseover="showImageModal = true" @mouseout="showImageModal = false">{{$t('com.file.prepare-meeting-invitation.show-doc-schema')}}</span>
                    </p>
                </section>

                <section class="esesja-modal__wraper__body__bottom">
                    <button class="esesja-modal__wraper__body__bottom-button" @click="() => { $store.commit('setPrepareMeetingInvitationModalStatus', false); }">{{ $t('com.global.close') }}</button>
                    <button class="esesja-modal__wraper__body__bottom-button esesja-modal__wraper__body__bottom-button--red" @click="downloadInvitationFile" :disabled="selectedUsers.length <= 0">{{ $t('com.global.download') }} (.docx)</button>
                </section>
            </perfect-scrollbar>
        </section>

        <ShowImageModal v-if="showImageModal" :imgContent="imgContent" />

    </section>
</template>
<script charset="utf-8">
    // services
    import AlertHelper from "../../../helpers/alerts.helper";
    import ContactService from "../../../services/contact.service";
    import SessionService from "../../../services/session.service";
    import UserService from "../../../services/user.service";
    import moment from "moment";
    import CKEditor from '@ckeditor/ckeditor5-vue';
    import 'ckeditor5/build/ckeditor5-dll.js';
    import '@ckeditor/ckeditor5-editor-classic/build/editor-classic.js';
    import '@ckeditor/ckeditor5-essentials/build/essentials.js';
    import '@ckeditor/ckeditor5-autoformat/build/autoformat.js';
    import '@ckeditor/ckeditor5-basic-styles/build/basic-styles.js';
    import '@ckeditor/ckeditor5-block-quote/build/block-quote.js';
    import '@ckeditor/ckeditor5-heading/build/heading.js';
    import '@ckeditor/ckeditor5-image/build/image.js';
    import '@ckeditor/ckeditor5-indent/build/indent.js';
    import '@ckeditor/ckeditor5-link/build/link.js';
    import '@ckeditor/ckeditor5-list/build/list.js';
    import '@ckeditor/ckeditor5-paste-from-office/build/paste-from-office.js';
    import '@ckeditor/ckeditor5-table/build/table.js';
    import '@ckeditor/ckeditor5-alignment/build/alignment.js';
    import ShowImageModal from '../Session/ShowImageModal.vue'
    // Components
    import Multiselect from '@vueform/multiselect'
    import PointsNumerationHelper from "@/helpers/pointsNumeration.helper";
    import MultiselectPersonTag from "../../BasicControls/Multiselect/MultiselectPersonTag.vue";
    import { showSessionName } from "../../../helpers/session.helper";

    export default {
        name: "PrepareMeetingInvitation",
        components: {
            Multiselect,
            ckeditor: CKEditor.component,
            ShowImageModal,
            MultiselectPersonTag
        },
        data() {
            return {
                showImageModal: false,
                imgContent: require('@/assets/imgs/schemat_zaproszenia_2.png'),
                editor: window.CKEditor5.editorClassic.ClassicEditor,
                editorConfig: {
                    plugins: [
                        window.CKEditor5.essentials.Essentials,
                        window.CKEditor5.autoformat.Autoformat,
                        window.CKEditor5.basicStyles.Bold,
                        window.CKEditor5.basicStyles.Italic,
                        window.CKEditor5.blockQuote.BlockQuote,
                        window.CKEditor5.heading.Heading,
                        window.CKEditor5.image.Image,
                        window.CKEditor5.image.ImageCaption,
                        window.CKEditor5.image.ImageStyle,
                        window.CKEditor5.image.ImageToolbar,
                        window.CKEditor5.image.PictureEditing,
                        window.CKEditor5.indent.Indent,
                        window.CKEditor5.link.Link,
                        window.CKEditor5.list.List,
                        window.CKEditor5.paragraph.Paragraph,
                        window.CKEditor5.pasteFromOffice.PasteFromOffice,
                        window.CKEditor5.table.Table,
                        window.CKEditor5.table.TableToolbar,
                        window.CKEditor5.typing.TextTransformation,
                        window.CKEditor5.alignment.Alignment
                    ],
                    toolbar: {
                        items: [
                            'undo', 'redo', '|', 'heading', '|', 'bold', 'italic', '|',
                            'link', 'insertTable', 'blockQuote', '|',
                            'bulletedList', 'numberedList', 'outdent', 'indent', '|', 'alignment'
                        ]
                    },
                    alignment: { options: ['left', 'center', 'right'] },
                    image: {
                        toolbar: [
                            'imageStyle:inline', 'imageStyle:block', 'imageStyle:side', '|',
                            'toggleImageCaption', 'imageTextAlternative'
                        ]
                    },
                    table: { contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'] }
                },
                selectedUsers: [],
                body: '',
                header: '',
                footer: '',
                availableUsers: [],
                sessionData: {
                    name: "",
                    meeting_date: "",
                    groups: [],
                },
                sessionDataLink: '',
                errors: [],
                sessionsToSelect: [],
                selectedSession: 0,
                firstLvl: 1,
                secondLvl: 2,
                thirdLvl: 3,
            }
        },
        async mounted() {
            try {
                this.$store.commit("showLoader");
                await this.internalFetchSessionsList();
                await this.internalFetchAvailableUsers();
                await this.internalFetchSessionData();
                await this.internalFetchUserInvitationData();
            }
            finally {
                this.$store.commit("hideLoader");
            }
        },
        methods: {
            checkSelectedSession() {
                this.$store.commit("showLoader");
                SessionService.getPoints(this.selectedSession).then((response) => {
                    this.prepareAllPointsForSelect(response.data);
                    this.$store.commit("hideLoader");
                }).catch((e) => {
                    console.log(e);
                    this.$store.commit("hideLoader");
                });
            },
            prepareAllPointsForSelect(list) {
                var tempPoints = [];
                var pointsToSelect_temp = list.filter(x => x.is_hidden == false);
                var pointsToSelect = PointsNumerationHelper.setOrderToDisplayRecursive([...pointsToSelect_temp])

                // prepare agenda groups points
                var session_group_data = this.sessionData.groups;
                if (session_group_data != undefined && session_group_data != null && session_group_data.length > 0) {
                    this.firstLvl = session_group_data[0].agenda_number_format_1_id;
                    this.secondLvl = session_group_data[0].agenda_number_format_2_id;
                    this.thirdLvl = session_group_data[0].agenda_number_format_3_id;
                }

                for (var i = 0; i < pointsToSelect.length; i++) {
                    tempPoints.push(this.filterIndex(pointsToSelect[i], 0) + " " + pointsToSelect[i].name);

                    if (pointsToSelect[i].children != null && pointsToSelect[i].children.length > 0) {
                        for (var j = 0; j < pointsToSelect[i].children.length; j++) {

                            tempPoints.push('\xA0\xA0\xA0 ' + this.filterIndex(pointsToSelect[i].children[j], 1) + " " + pointsToSelect[i].children[j].name);

                            if (pointsToSelect[i].children[j].children != null && pointsToSelect[i].children[j].children.length > 0) {
                                for (var k = 0; k < pointsToSelect[i].children[j].children.length; k++) {
                                    tempPoints.push('\xA0\xA0\xA0\xA0\xA0\xA0 ' + this.filterIndex(pointsToSelect[i].children[j].children[k], 2) + " " + pointsToSelect[i].children[j].children[k].name);
                                }
                            }
                        }
                    }
                }

                this.body = '';

                var body = '';
                for (var v = 0; v < tempPoints.length; v++) {
                    body += tempPoints[v] + '<br>';
                }

                this.body += body;
            },
            filterIndex(elem, lvl) {
                return PointsNumerationHelper.filterIndex(elem.orderToDisplay, elem.number, lvl, this.firstLvl, this.secondLvl, this.thirdLvl);
            },
            async internalFetchSessionsList() {
                try {
                    let result = await SessionService.getAllSessionsYear();
                    if (result.status !== 200) {
                        throw await Promise.reject(result);
                    }

                    this.sessionsToSelect = result.data;
                }
                catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
            },
            showDate(date) {
                if (date != null && date != undefined && date.length > 0)
                    return this.$t('com.global.from-day') + " " + this.formatDateToDisplay(date);
            },
            formatDateToDisplay(value) {
                var date = new Date(value)
                var d = date.toLocaleString('default', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });

                return d;
            },
            formatDateToDisplayLong(value) {
                var date = new Date(value)
                var d = date.toLocaleString('default', {
                    year: 'numeric',
                    month: 'long',
                    weekday: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric'
                });

                return d;
            },
            customSearchFilter(option, query) {
                let localQuery = query.toUpperCase();
                let localcopy = [...this.availableUsers];
                // check if any groups meets criteria
                let filterGroup = localcopy.filter(item => {
                    let copyGroupLabel = item.label.toUpperCase()
                    return copyGroupLabel.includes(localQuery);
                })

                if (filterGroup.length > 0) {
                    let isOptionIsInGroup = filterGroup.filter(item => item.id === option.groupId);
                    return isOptionIsInGroup.length > 0;
                }
                return option.label.toUpperCase().includes(localQuery);
            },
            selectedOptions() {
                this.$refs.searchUsers.clearSearch();
            },
            async internalFetchAvailableUsers() {
                try {
                    let result = await ContactService.getUsersToSmsOrEmail(3);
                    if (result.status !== 200) {
                        throw await Promise.reject(result);
                    }

                    this.availableUsers = [ ... result.data]

                    this.availableUsers = this.availableUsers.map(item => ({
                        id: item.id,
                        label: item.label,
                        options: item.options.map(opt => ({
                            value: opt.value,
                            label: opt.label,
                            groupId: item.id
                        }))
                    }));
                }
                catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
            },

            async internalFetchSessionData() {
                try {
                    let result = await SessionService.getSession(this.$store.state.modals.sessions.prepareMeetingInvitationModalSessionId)

                    if (result.status !== 200) {
                        throw await Promise.reject(result);
                    }

                    this.sessionData = result.data;
                    this.selectedSession = result.data.id;
                    this.checkSelectedSession();
                }
                catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
            },

            async internalFetchUserInvitationData() {
                try {
                    let result = await UserService.getAdminUserInvitationData()

                    if (result.status !== 200 && result.status !== 204) {
                        throw await Promise.reject(result);
                    }

                    if (result.data != null) {

                        if (result.data.header != undefined && result.data.header != null) {
                            this.header = result.data.header;
                        }
                        else {
                            this.header = '';
                        }

                        if (result.data.footer != undefined && result.data.footer != null) {
                            this.footer = result.data.footer;
                        }
                        else {
                            this.footer = '';
                        }
                    }
                }
                catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
            },

            async downloadInvitationFile() {
                try {
                    this.$store.commit("showLoader");

                    var data = {
                        sessionId: this.selectedSession,
                        body: this.body,
                        header: this.header,
                        footer: this.footer,
                        peopleList: this.selectedUsers
                    };

                    let response = await SessionService.createExportedInvitationToWord(this.selectedSession, data);

                    if (response.status !== 200) {
                        throw await Promise.reject(response);
                    }

                    const contentType = response.headers['content-type'];
                    let a = document.createElement('a');
                    var blob = new Blob([response.data], { 'type': contentType });
                    a.href = window.URL.createObjectURL(blob);
                    var filename = response.headers['content-disposition'].split("filename=")[1];

                    filename = filename.substr(0, filename.indexOf(';'));
                    filename = filename.replaceAll('"', '');
                    a.download = filename
                    a.click();

                    //this.$store.commit('setPrepareMeetingInvitationModalStatus', false);
                    this.$swal(AlertHelper.successAlert(this.$t('com.file.prepare-meeting-invitation.success-download-alert'), this.$t('com.global.success')));
                }
                catch (e) {
                    console.log(e);
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },
            humanDate(date) {
                return moment(date).format("DD MMMM YYYY");
            },
            setInputFocus(){
                const input = this.$refs.searchUsers.$el.querySelector("input");
                if(input)
                    input.focus();
            },
            showSessionName
        }
    }
</script>
<style lang="scss" scoped>
    @use '@/assets/scss/esesja-modal.scss';

    ::v-deep(.multiselect-tags){
        column-gap: 7.5px;
        row-gap: 7.5px;
        max-height: 200px; 
        overflow: hidden; 
        scroll-behavior: smooth; 
        overflow-y: auto; 
    }

    ::v-deep(.multiselect-tags > .multiselect-tags-search-wrapper){
        order: -1;
        flex-basis: 100%;
    }

    .tooltip {
        cursor: pointer;
        font-size: 14px;
    }

    .send-meeting-regarding-modal {
        .esesja-modal__wraper {
            max-height: 90vh;
            min-width: 55vw;
        }

        .attached-file-wrapper {
            display: flex;
            flex-direction: row;
            gap: 10px;
            flex-wrap: wrap;

            &__item {
                display: flex;
                background: #e8ecf2;
                border-radius: 20px;
                padding: 10px 20px;
                flex-direction: row;
                align-content: center;
                align-items: center;
                gap: 5px;
                border: 1px solid transparent;
                transition: all 0.2s ease-in-out;


                &__remove {
                    opacity: 0;
                    transition: all 0.2s ease-in-out;
                }

                &:hover {
                    border-color: #bbc2ce;

                    .attached-file-wrapper__item__remove {
                        opacity: 1;
                        cursor: pointer;
                    }
                }
            }
        }

        .esesja-modal__row--to-right {
            justify-content: flex-end;
            align-items: flex-end;
        }

        .esesja-modal__wraper__body__input__file {
            padding-top: 0px !important;
            padding-bottom: 0px !important;
            padding-left: 0px !important;


            &::file-selector-button {
                background: #fff;
                padding: 12.5px 15px;
                border: none;
                transition: all 0.2s ease-in-out;
                cursor: pointer;

                &:hover {
                    background: #e8ebef;
                }
            }
        }

        .esesja-modal__row__as-column {
            flex-direction: row;
            column-gap: 10px;

            .esesja-modal__wraper__body__bottom-button {
                padding: 18px 15px 17px;
            }
        }
    }
   
</style>